import React from "react";
// State
import { useSelector } from "react-redux";
import { selectMode } from "../app/appSlice";
import { selectProjects } from "../app/projectsSlice";
import { useGetProjectsQuery } from "../app/apiSlice";
// Router
import { Link } from "react-router-dom";
// Components
import { Element } from "react-scroll";
import { Button, Col, Container, Row } from "react-bootstrap";
import Loading from "./Loading";
import Title from "./Title";
import ProjectCard from "./ProjectCard";

import GHLogo from "../images/GH.svg";
import EarthMap from "../images/earth.png";
import Interbellum from "../images/interbellum.png";

// #region component
const Projects = () => {
    const theme = useSelector(selectMode);
    const projects = useSelector(selectProjects);
    const { isLoading, isSuccess, isError, error } = useGetProjectsQuery();

    // 👇 your 3 personal projects
    const myMainProjects = [
        {
            id: "github",
            name: "My GitHub Profile",
            description: "Check out all of my open-source projects on GitHub.",
            image: GHLogo, // put this in public/images
            url: "https://github.com/ItsJuls",
            demo: null,
        },
        {
            id: "earthmap",
            name: "Earth Maps",
            description: "Custom Minecraft Earth map I built.",
            image: EarthMap,
            url: "https://www.planetminecraft.com/project/1-1500-custom-earth-map-with-custom-biomes-custom-caves-and-vanilla-structures/", // your link here
            demo: null,
        },
        {
            id: "discord",
            name: "Interbellum",
            description: "Join my Minecraft Server on Discord!",
            image: Interbellum,
            url: "https://discord.gg/vhFnvMMcub",
            demo: null,
        },
    ];

    let content;

    if (isLoading) {
        content = (
            <Container className="d-flex">
                <Loading />
            </Container>
        );
    } else if (isSuccess) {
        content = (
            <>
                <Row xs={1} md={2} lg={3} className="g-4 justify-content-center">
                    {/* 👇 always render your 3 personal projects first */}
                    {myMainProjects.map((project) => (
                        <Col key={project.id}>
                            <ProjectCard
                                image={project.image}
                                name={project.name}
                                description={project.description}
                                url={project.url}
                                demo={project.demo}
                            />
                        </Col>
                    ))}
                </Row>

                {/* 👇 then show button to GitHub projects */}
                {projects.length > 0 && (
                    <Container className="text-center mt-5">
                        <Link to="/All-Projects">
                            <Button
                                size="lg"
                                variant={theme === "light" ? "outline-dark" : "outline-light"}
                            >
                                All Works
                            </Button>
                        </Link>
                    </Container>
                )}
            </>
        );
    } else if (isError) {
        content = (
            <Container className="d-flex align-items-center justify-content-center">
                <h2>{`${error.status} - check getProjects query in src/app/apiSlice.js`}</h2>
            </Container>
        );
    }

    return (
        <Element name={"Projects"} id="projects">
            <section className="section">
                <Container>
                    <Container className="d-flex justify-content-center">
                        <Title size={"h2"} text={"Projects"} />
                    </Container>
                    {content}
                </Container>
            </section>
        </Element>
    );
};
// #endregion

export default Projects;
